<template>
  <el-input
    v-model="tValue"
   @change="handleChange"
   :placeholder="placeholder"
   clearable
   size="mini"
  ></el-input>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ColumnInputDesc',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  created () {
    this.tValue = this.desc(this.rowId)
  },
  data () {
    return {
      tValue: ''
    }
  },
  computed: {
    ...mapGetters({
      desc: 'edit/lineDesc'
    })
  },
  methods: {
    ...mapMutations({
      setDesc: 'edit/setLineDescription'
    }),
    handleChange () {
      this.setDesc({ id: this.rowId, desc: this.tValue })
    }
  },
  inject: ['bus']
}
</script>
